export default __webpack_public_path__ + "static/media/logoproccess.d49fee29.png";